<style>
	.bgss {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar6{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar6 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar6 span.pos{  padding:0 1vw;}
.tabbar6 span.floder{ color:#666;}
 
.tabbar6 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}
 
.steps{width:84vw;height:6vw;margin:0;padding:0;overflow:hidden; 
border-bottom:#f3f7f8 solid 1px;margin-top:7vw;position:relative;margin-left:7vw;
 }
.steps ul{width:65vw;height:3.5vw; float:left;box-sizing:border-box;box-sizing:border-box;position:absolute;top:0;cursor:pointer;}
.steps ul li{float:left; height:3.5vw;line-height:3.5vw;font-size:1.4vw;box-sizing:border-box;text-align:center;padding: 0 1vw;}
.steps ul li.on{border-bottom:#3268ff solid 0.15vw;color:#3268ff; }
.steps ul li:hover{background:#f1f1f1; }



.new_template3{width:12vw;float:right;height:3vw;border:#4471ff solid 1px;margin-top:.5vw;border-radius:.5vw;cursor:pointer;}
.new_template3 img{width:2vw;margin-top:.5vw;margin-left:.5vw;display:block;float:left;margin-left:1vw;}
.new_template3 span{display:block;float:left; text-align:center;line-height:3vw;font-size:1.2vw; 
  color:#4471ff;margin-left:.6vw;}
  
  
.new_template3:hover{background:#4471ff;color:#fff; }
.new_template3:hover span{color:#fff;}
  
.templates{width:82vw; margin-top:1vw;height:28vw;}
.template_box{width:38vw;height:13.2vw; position:relative;background: url(../../assets/images/unselected2.png) no-repeat;background-size:100% 100%;border-radius:.5vw;
margin-top:1vw;cursor:pointer;padding:0 1vw;float:left;}
.pull-left{float:left;}
.pull-right{float:right;}

.template_box p{position:absolute;font-size:1vw;width:31.5vw;left:1.5vw;top:1.5vw;line-height:2vw;height:10vw;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp:5;
overflow: hidden;}
.pass{width:2.4vw;height:2.4vw;position:absolute;top:2.2vw;right:2vw;background:#32ad37;border-radius:2.4vw;}
.pass img{width:1.4vw;display:block;margin:0 auto;margin-top:.5vw;}

.template_box span{display:block;position:absolute;}
.template_box span.msg1{font-size:1vw;right:0;top:5vw;color:#32ad37;width:5vw;margin-right:.5vw;}
.template_box span.msg2{font-size:1vw;right:0;top:5vw;color:#FA9D3C;width:4.4vw;margin-right:.5vw;}
.template_box span.edit{font-size:1vw;right:2.1vw;top:7vw;color:#3465ff;width:3vw;margin-right:.7vw;text-decoration:underline;text-align:left;}
.template_box span.del{font-size:1vw;right:0.5vw;top:7vw;color:#3465ff;width:3vw;margin-right:.7vw;text-decoration:underline;text-align:right;}

.selected{background: url(../../assets/images/selected2.png) no-repeat;background-size:100% 100%;}
.pages{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:2.5vw; margin-top:2vw;} 
/*.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}*/
.pre11{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;background: #fff;
background-image: url(../../assets/images/pre2.png);background-size: 2vw 2vw;background-position: center center;}
.pre11:hover{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;background: #fff;
background-image: url(../../assets/images/pre1.png);background-size: 2vw 2vw;background-position: center center;background-color: #3268ff;}
.pre111{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;background: #fff;
background-image: url(../../assets/images/pre1.png);background-size: 2vw 2vw;background-position: center center;}


/*.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;background: #fff;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}
.next:hover{background: #3268ff;}*/
.next22{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;background: #fff;
background-image: url(../../assets/images/next1.png);background-size: 2vw 2vw;background-position: center center;}

.next22:hover{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;background: #fff;
background-image: url(../../assets/images/next11.png);background-size: 2vw 2vw;background-position: center center;background-color: #3268ff;}
.next222{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;background: #fff;
background-image: url(../../assets/images/next2.png);background-size: 2vw 2vw;background-position: center center;}




.submits{width:12vw;height:4vw;background:#3268ff;margin-top:2vw;border-radius:.5vw;cursor:pointer}
.submits span{display:block;float:left;width:8vw;text-align:center;color:#fff;font-size:1.4vw;line-height:4vw;}
.submits img{display:block;float:left;width:2vw;margin-top:1vw;height:2vw;}
.submits:hover{background:#4C84FA;}




.blank_area{width:100%;height:30vw;}
.blank_area span{display:block;width:100%;text-align:center;line-height:30vw;font-size:1.2vw;}
.blank_area b{font-weight:normal;color:#3465ff;cursor:pointer;text-decoration:underline;}
.borders{width:1px;height:10vw;border-right:#ddd solid 1px;position:absolute;right:6.2vw;
top:1.5vw;}
.mengban{width:100vw;height:100vh;position:fixed;top:0;z-index:999;
background:url(../../assets/images/yao_bg4.png) repeat;}


.progress222{width:35vw;height:20vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd222{width:100%;height:4vw;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}
.progress_hd222 span.ap{display:block;width:40%;margin-left:30%;float:left;line-height:4vw;text-align:center;}
 

 
.progress222 p{display:block;width:90%;text-align:center;line-height:5vw;
font-size:1.2vw;margin:0 auto;
color:#333;margin-top:2vw;}
 
.confirm_boxes{width:100%;margin:0 auto;height:4vw; 
margin-top:2vw;}
.progress222 button.submits441{width:35%;margin:0 auto;height:3.5vw;background:#3465ff;display:block; 
border:0;outline:none;float:left;margin-left:5vw;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
.progress222 button.submits441:hover{background:#4C84FA;}
 
.progress222 button.submits442{width:35%;margin:0 auto;height:3.5vw;background:#ccc;display:block; 
border:0;outline:none;float:right;margin-right:5vw;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
</style>
<template>
	<div class="bgss">
	     <u_center  ></u_center>
	     <div class="top_area" title="返回首页">
		    <img  @click="back()" src="../../assets/images/home_icon.png">
			<div class="tabbar6">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">发送短信通知</span>
			   <span class="rights"></span>
			   <span class="floder">选择短信模板</span>
			</div>
		 </div>
		 <transition name="draw">
		 <div class="mengban" v-show="del_show"></div>
		  </transition>
		 <transition name="draw">
		 <div class="progress222" v-show="del_show">
				  <div class="progress_hd222"><span class="ap">删除提示</span></div>
				  <p :style="msg_style">{{del_msg}}</p>  
				  <div class="confirm_boxes">
					   <button class="submits441" @click="del_sure()">确定</button>
					   <button class="submits442" @click="del_cancel()">取消</button>
				  </div>
		 </div>
         </transition>
   
   
         <transition name="draw">
		 <div class="mengban" v-show="edit_show"></div>
		  </transition>
		 <transition name="draw">
		 <div class="progress222" v-show="edit_show">
				  <div class="progress_hd222"><span class="ap">编辑提示</span></div>
				  <p  style="color:#f00;line-height:2.4vw;">该模板已通过审核</br>修改后需再次审核，是否继续？</p>  
				  <div class="confirm_boxes">
					   <button class="submits441" @click="edit_sure()">确定</button>
					   <button class="submits442" @click="edit_cancel()">取消</button>
				  </div>
		 </div>
         </transition>
		 
		 
		 
		   
		 <div class="steps">
		      <ul>
			     <li :class="item.class" v-for="item in steps" @click="step(item.id)">{{item.name}}</li> 
			  </ul>
			  <div class="new_template3" @click="add_template()"  @mouseover="mouseOver_sms()"  @mouseleave="mouseLeave_sms()">
			     <img :src="sms_code" >
				 <span>新增短信模板</span>
			  </div>
		 </div>
		 <div class="templates">
		 <div  v-if="nodata">
		    <div v-for="item in list" >
			     
						  <div class="template_box" :class="item.class" @click="choose(item.id)" :style="item.style" >
							  
							   <div v-if="item.status==1">
								   <p >{{item.content}}</p>
								   <div class="borders"></div>
								   <div class="pass"><img src="../../assets/images/gou.png"></div>
								   <span class="msg1">审核通过</span>
								   <span class="edit" @click="edit_temp(item.id,item.status)">编辑</span>
								   <span class="del" @click="del_temp(item.id,item.status)">删除</span>
							   </div>
							   <div v-else>
								   <p style="color:#ccc">{{item.content}}</p>
								   <div class="borders"></div>
								   <div class="pass" style="background:#f8b874;"> <img src="../../assets/images/tan.png"></div>
								   <span class="msg2">审核中</span>
								   <span class="edit"   @click="edit_temp(item.id,item.status)">编辑</span>
								   <span class="del" @click="del_temp(item.id,item.status)"  >删除</span>
							   </div>
						  </div>
			 </div>
			 </div>
			 <div class="blank_area" v-else>
			    <span>暂无短信模板请<b @click="add_template()" >添加</b></span>
			 </div>
		 </div>
		 
		 <div class="pages">
		 	<div class="pre111"  v-if="page<total_page"></div>
		     <div class="pre11" @click="prev()"   v-else></div>
		    

			<div class="next22" @click="next()" v-if="page<total_page"></div>
			<div class="next222" @click="next()" v-else></div>
		 </div>
		 <div class="submits" @click="nextstep()">
		     <span>继续</span>
			 <img src="../../assets/images/more.png">
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
	export default {
	    components: {
		  u_center,
	    },
		data() {
			return {
				steps:[],
				list:[],
				token:"",
				type:"",
				page:1,
				del_id:"",
				edit_id:"",
				del_show:false,
				edit_show:false,
				 msg_style:"",
				total_page:"1",
				template:"",
				nodata:true,
				del_msg:"是否确认删除该条模板?",
				sms_code:"https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code.png",
			}
		},
		mounted() {
		     let self=this;
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_sms_type();
			  }  
			 
			
		},
		methods: {
			del_temp(id,status){
			  this.del_show=true;
			  this.del_id=id;
			  if(status==2){
			    this.msg_style="color:#333;"
			    this.del_msg="是否确认删除该条模板?";
			  }else{
			    this.msg_style="color:#f00;"
			    this.del_msg="该模板已通过审核，是否确定删除?";
			  }
			}, 
			edit_temp(id,status){
			  
			  if(status==2){
			    this.edit_templete(id);
			  }else{
			     this.edit_show=true;
			     this.edit_id=id;
			  }
			}, 
			edit_sure(){
			   this.edit_templete(this.edit_id);
			},
			del_cancel(){
			   this.del_show=false;
			},
			edit_cancel(){
			   this.edit_show=false;
			},
		    mouseOver_sms() {
			   this.sms_code="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code2.png";

		   },mouseLeave_sms() {
		       this.sms_code="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code.png";
		   },
		    back(){
		      this.$router.push("/");  
		   },
		   edit_templete(id){
		      this.$router.push("/edit_templete?id="+id);  
		   },
		   nextstep(){
			   if(!this.template || this.template<=0){
			     this.$toast.center('请选择模板');	
				 return;
			   }
		      this.$router.push("/import_data?template="+this.template);  
		   },
		   next(){
		      if(this.page<this.total_page){
			     this.page=this.page+1;
			     this.get_sms_template();
				 if(this.page==this.total_page){
				  // this.$refs.next.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/next2.png'
				   if(this.total_page>1 &&  this.page>1){
				   //  this.$refs.pre.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre2.png'
				   }
				 }
			  }else if(this.total_page>1 && this.page>1){
				   //  this.$refs.pre.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre2.png'
			  } 
			     
			   
		   },prev(){
		      if(this.page>1){
			     this.page=this.page-1;
			     this.get_sms_template();
				 if(this.page==1){
				  // this.$refs.pre.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre1.png'
				   if(this.total_page>1 &&  this.page<this.total_page){
				  //   this.$refs.next.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/next1.png'
				   }
				 }
			  }
		   },
		   add_template(){
		      if(!this.type){
			    this.type=1;
			  }
			 var code ="" ;
			 for(var i=0;i<6;i++){
				var radom = Math.floor(Math.random()*10);
				code += radom;
			  }
		      this.$router.push("/select_add?type="+this.type+"&code="+code);  
		   },del_sure(){
		      let self=this;
		      axios.post(this.$api+'/message/del_templete', {
					   token:self.token,
					   id:self.del_id
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					  self.$toast.center('删除成功');
                      self.del_show=false;					  
                      self.get_sms_template();					  
				  }else{                
					  self.$toast.center(data.msg); 		 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },
		   get_sms_type(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sms_type', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.steps=data.data;	
					 if(self.steps[0]){
					    self.steps[0].class='on';
						self.type=self.steps[0].id;
						self.get_sms_template();
					 }				 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		  get_sms_template(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sms_template', {
					   token:self.token,
					   type:self.type,
					   page:this.page
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.list=data.data.list;
                     self.total_page=	data.data.total_page;	
					var counts=[];                   
					self.list.forEach(function(obj,index){
						 counts++
					});
					if(counts==0){
					  self.nodata	=false;
					}else{
					  self.nodata	=true;
					}
				 console.log(self.nodata)
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		   step(id){
		        var new_list=[];                   
				this.steps.forEach(function(obj,index){
					new_list[index]=obj;
					if( obj.id==id){
						new_list[index].class='on';
					}else{
					    new_list[index].class='';
					}
				});
			    this.steps=new_list;
				this.type=id;
				this.page=1;
				//this.$refs.next.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/next1.png'
			//	this.$refs.pre.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre1.png'
				this.get_sms_template();
				
				
		   },choose(id){
		        var new_list=[];   
		        let self=this                
				this.list.forEach(function(obj,index){	
					new_list[index]=obj;
					if( obj.id==id){
					    if(obj.status==1){
						   new_list[index].class='selected';
						}else{
							 self.$toast.center('模板正在审核中'); 	
						}
					}else{
					    new_list[index].class='';
					}
					
				});
			    this.list=new_list;
				this.template=id;
		   }
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/select_template.vue